<template>
    <div class="standalone-video-seek-bar">
        <b-form-slider
            id="video-seek-bar"
            ref="videoSeekBar"
            orientation="horizontal"
            :value="seekValue"
            :min="0"
            :max="1000"
            :step="1"
            :ticks="tickValues"
            class="video-seek-bar"
            @change="seekChangeHandler"
        />

<!--        <b-tooltip-->
<!--            v-if="well.inferenceData"-->
<!--            custom-class="well-preview-tooltip"-->
<!--            target="video-seek-bar"-->
<!--            :delay="{ show: 0, hide: 1000 }"-->
<!--            triggers="hover"-->
<!--        >-->
<!--            <div class="justify-center p-2">-->
<!--                <div class="mr-auto well-time-container rounded flex-column pr-2">-->
<!--                    <span class="text-size-9 text-light-1">-->
<!--                        {{ $translate('time') }}-->
<!--                    </span>-->
<!--                    <span class="text-size-13 text-bold">-->
<!--                        {{ $translate('hour_x', currentWellTime_h) }}-->
<!--                    </span>-->
<!--                </div>-->

<!--                <well-score-metrics-->
<!--                    v-if="!isFdaFriendly"-->
<!--                    :well="well"-->
<!--                    size="tooltip"-->
<!--                    class="mr-1"-->
<!--                    :color-background="false"-->
<!--                    :current-well-time-hours="currentWellTime_h"-->
<!--                />-->
<!--            </div>-->
<!--        </b-tooltip>-->
    </div>
</template>

<script>
import WellScoreMetrics from './WellScoreMetrics'
import { mapGetters } from 'vuex'

export default {
    name: 'StandaloneVideoSeekBar',
    components: { WellScoreMetrics },
    props: {
        well: {
            type: Object,
            required: true
        },
        videoLength_s: {
            type: Number,
            required: true
        },
        firstRunTime_h: {
            type: Number,
            required: true
        },
        currentTimeCode_s: {
            type: Number,
            required: true
        },
        currentWellTime_h: {
            type: Number,
            required: true
        },
        slideIncubationLength: {
            type: Number,
            required: true
        }
    },
    computed: {
        ...mapGetters({
            isFdaFriendly: 'common/isFdaFriendly'
        }),
        seekValue() {
            return (this.currentTimeCode_s / this.videoLength_s) * 1000
        },
        tickValues() {
            if (this.isFdaFriendly || !this.well.inferenceData) {
                return []
            }

            const { morphokinetics } = this.well.inferenceData

            return [];//morphokinetics.map(mk => this.calculateLeftValue(mk.value))
        }
    },
    methods: {
        calculateLeftValue(mkValue) {
            const eventDurationHours = mkValue - this.firstRunTime_h
            const slideDurationHours = this.slideIncubationLength - this.firstRunTime_h

            return (eventDurationHours / slideDurationHours) * 1000
        },
        seekChangeHandler(event) {
            const timeCode = (this.videoLength_s * event.newValue) / 1000
            this.$emit('seekVideoTo', timeCode)
        }
    }
}
</script>

<style lang="scss">
.standalone-video-seek-bar {
    display: flex;
    align-items: center;
    height: 2rem;
    margin-bottom: 1rem;
    z-index: 20;

    .video-seek-bar {
        width: 100%;

        .slider {
            width: 100%;

            .slider-track {
                height: 0.5rem;
                border-radius: 0;
                top: 10px;
                background-image: none;
                background-color: $dark-4;

                .slider-track-low,
                .slider-track-high {
                    background-image: none;
                }

                .slider-selection {
                    background-image: none;
                    background-color: $blue;
                }
            }

            .slider-tick-container {
                top: 5px;

                .slider-tick {
                    width: 0;
                    height: 0.5rem;
                    margin-left: unset;
                    border-radius: unset;
                    border-left: 1px solid $light-4;
                    border-right: 1px solid $light-4;
                    pointer-events: none;

                    &.in-selection {
                        border-left: 1px solid $blue;
                        border-right: 1px solid $blue;
                    }
                }
            }

            .slider-handle {
                background: $blue;
                width: 1.5rem;
                height: 1.5rem;
                margin-left: -0.75rem;
                border: 0.4rem solid $dark-4;
                margin-top: -0.2rem;
                cursor: pointer;
                z-index: 20;

                &:hover {
                    border-color: $dark-5;
                }
            }
        }
    }

    .well-preview-tooltip {
        z-index: 20;
        opacity: 1 !important;

        .tooltip-inner {
            background-color: $dark-2;
            box-shadow: 0 0 0.3rem rgba(0, 0, 0, 0.5) !important;
        }
        .arrow::before {
            border-top-color: $dark-2;
        }
        img.high {
            display: block;
            width: 100%;
            height: 100%;
        }
        .well-tooltip-details {
            top: 0.5rem;
            margin-bottom: -2rem;
            position: relative;
        }
    }
}
</style>
